/**
 * 動画の視聴計測。
 *
 * Shopify.analytics.publish() でカスタムピクセルにイベントを送る。
 * テーマのJSはサンドボックス外で動くため gtag を直接呼べない。
 * 受け手のピクセルが未設定でも publish() は空振りするだけで害はない。
 */
(function () {
  'use strict';

  if (window.VideoAnalytics) return;

  // 0.7交差からこの時間だけ表示が続いたらビューとして数える。
  // スワイプで通過しただけの動画を除外するため。
  var VIEW_THRESHOLD_MS = 1000;

  var viewed = {};
  var pending = {};

  function videoKey(videoData, context) {
    return context + ':' + (videoData.handle || 'index-' + videoData.index);
  }

  /**
   * GA4の標準eコマース item 形式に変換する。
   * items は標準パラメータのためカスタムディメンション枠を消費しない。
   */
  function buildItems(products) {
    return products.map(function (p, i) {
      return {
        item_id: p.sku || p.variantId || '',
        item_name: p.title || '',
        item_brand: p.brand || '',
        price: typeof p.priceAmount === 'number' ? p.priceAmount : undefined,
        index: i
      };
    });
  }

  /**
   * パラメータは動画専用にせず汎用名で揃える。
   * GA4のイベントスコープ カスタムディメンションは50個までのため、
   * コーデ・ルックブック等の他コンテンツでも使い回せる語彙にしている。
   */
  function buildPayload(videoData, context) {
    var model = videoData.model;
    var handle = videoData.handle || '';

    return {
      content_type: 'video',
      content_id: handle,
      creator_name: (model && model.name) || '',
      placement: context,
      video_title: handle,
      items: buildItems(videoData.products || [])
    };
  }

  function publish(videoData, context) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;

    try {
      analytics.publish('video_start', buildPayload(videoData, context));
    } catch (e) {
      // 計測の失敗で再生を妨げない
    }
  }

  /**
   * 動画が表示され始めたことを通知する。
   * VIEW_THRESHOLD_MS のあいだ表示が続いて初めてイベントが飛ぶ。
   */
  function trackViewStart(videoData, context) {
    if (!videoData) return;

    var key = videoKey(videoData, context);
    if (viewed[key] || pending[key]) return;

    pending[key] = setTimeout(function () {
      delete pending[key];
      viewed[key] = true;
      publish(videoData, context);
    }, VIEW_THRESHOLD_MS);
  }

  /** 閾値に届く前に離脱した場合、保留中の発火を取り消す。 */
  function trackViewEnd(videoData, context) {
    if (!videoData) return;

    var key = videoKey(videoData, context);
    if (!pending[key]) return;

    clearTimeout(pending[key]);
    delete pending[key];
  }

  /** モーダルを閉じたときに保留中の発火をすべて破棄する。 */
  function reset() {
    Object.keys(pending).forEach(function (key) {
      clearTimeout(pending[key]);
    });
    pending = {};
  }

  window.VideoAnalytics = {
    trackViewStart: trackViewStart,
    trackViewEnd: trackViewEnd,
    reset: reset
  };
})();
